const getType = (identificador: string) => identificador.split(' ')[1];

export const compareCourses = (
	a: { identificadorNivel: string; nivel: number },
	b: { identificadorNivel: string; nivel: number },
	keepAlphaSort: boolean
) => {
	const typeOrder = [
		'universidad',
		'medio',
		'media',
		'básico',
		'nt',
		'preparatoria',
		'secundaria',
		'primaria',
		'pre-escolar',
		'transición',
		'transicion'
	];
	const typeA = getType(a.identificadorNivel);
	const typeB = getType(b.identificadorNivel);

	// Ordenar por tipo según el índice en typeOrder
	if (typeOrder.indexOf(typeA) !== typeOrder.indexOf(typeB)) {
		return typeOrder.indexOf(typeA) - typeOrder.indexOf(typeB);
	}

	// Si los tipos son iguales, ordenar por nivel numérico
	if (a.nivel !== b.nivel) {
		return b.nivel - a.nivel; // Orden descendente de nivel
	}

	// Si el nivel también es igual, ordenar alfabéticamente por identificadorNivel
	return keepAlphaSort
		? a.identificadorNivel.localeCompare(b.identificadorNivel)
		: b.identificadorNivel.localeCompare(a.identificadorNivel);
};

export const sortCourses = (dataCurso: any, sortAsc: any) => {
	const sortedCourses = [...dataCurso]?.sort((a, b) => {
		return sortAsc ? compareCourses(a, b, true) : compareCourses(b, a, false);
	});
	return { sortAsc: !sortAsc, sortedCourses };
};

export const sortCoursesMintoMax = (dataCurso: any) => {
	return sortCourses(dataCurso, true)?.sortedCourses;
};

export const sortCoursesMaxtoMin = (dataCurso: any) => {
	return sortCourses(dataCurso, false)?.sortedCourses;
};
